export const environment = {
  production: true,
  apiUrl: 'https://createmydatabook-processor-dev.sbp.eyclienthub.com/api/',
  usApiUrl: 'https://createmydatabook-processor-dev.sbp.eyclienthub.com/api/',
  apacApiUrl: 'https://createmydatabook-processor-dev.sbp.eyclienthub.com/api/',
  pageRows: 10,
  pageRows25: 25,
  maxFilesUploads: 5,
  concurrentUploads: 2,
  maxFileSize: 6, // in MB
  maxSourceFileSize: 10, // in MB
  maxFlatFileSizeUploadLimit: 20,
  minFlatFileSizeToSendEmail: 6144, // in KB =6MB
  maxPreviewFileSize: 512000,//500 KB
  env: 'dev',
  pageSize: 1000,
  tenant: 'eygs.onmicrosoft.com',
  clientId: '901e531c-5904-4a5f-8163-e8da740c2937',
  redirectUri: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
  extraQueryParameter: 'domain_hint = eyclienthub.com',
  authority: 'https://login.microsoftonline.com/eygs.onmicrosoft.com',
  isWebJobEnabled: true,
  webjobTimer: 30000,
  isBearerAuthorizationEnabled: true, 
  isMsalEnabled: true,
  sampleToken: '000',
  webAppUrl: 'https://createmydatabook-dev.sbp.eyclienthub.com',
  sessionTimeout: 3540, // in seconds
  version: '16/07/2022 01:20:04 AM EST',
  processorVersion: 'v3.1',
  ENV: 'Dev',
  supportedLangs: [{ name: 'English', code: 'en-US' }, { name: 'Español', code: 'es-ES' }, { name: 'Deutsche', code: 'de-DE' }]
};
